import { domainArray } from "./appUrl";

export const neoauth =
  import.meta.env.VITE_ENV === "local"
    ? import.meta.env.VITE_NEOAUTH
    : `https://login.${domainArray}/`;

export const CENTRAL_API_URL = import.meta.env.VITE_CENTRALAPI;

export const NO_API_SOFTWARES = ["fec", "quadraod", "myunisoft", "cegid"];
